import { render, staticRenderFns } from "./GameLoginOverlay.vue?vue&type=template&id=00a2edc6&scoped=true&"
import script from "./GameLoginOverlay.vue?vue&type=script&lang=js&"
export * from "./GameLoginOverlay.vue?vue&type=script&lang=js&"
import style0 from "./GameLoginOverlay.vue?vue&type=style&index=0&id=00a2edc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a2edc6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00a2edc6')) {
      api.createRecord('00a2edc6', component.options)
    } else {
      api.reload('00a2edc6', component.options)
    }
    module.hot.accept("./GameLoginOverlay.vue?vue&type=template&id=00a2edc6&scoped=true&", function () {
      api.rerender('00a2edc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/User/GameLoginOverlay.vue"
export default component.exports